import { decisionCardStyles } from '../../policy-drafting.styles';

const styles = (theme) => ({
  ...decisionCardStyles(theme),
  noteRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(4),
    '& .MuiFormControl-root': {
      flex: 1
    },
    '& button': {
      whiteSpace: 'nowrap',
      flexShrink: 0,
      // the note field reserves 16px above its input for the MUI floating label; match it so
      // the button and input line up
      marginTop: 16
    }
  },
  farmPolicyContainer: {
    marginTop: theme.spacing(9)
  },
  lockedOptionLabel: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(2)
  },
  lockIcon: {
    width: 16,
    height: 16
  },
  notification: {
    minHeight: 30,
    boxShadow: 'none',
    '& img': {
      fontWeight: 400
    }
  }
});

export default styles;
